const api =
  process.env.NODE_ENV === "production"
    ? "https://kb.huestimates.app/api/controller"
    : "http://localhost:7740/controller";
const publicUrl = process.env.NODE_ENV === "production"
? "https://kb.huestimates.app/#/public/start/"
: "http://localhost:8080/#/public/start/";
const uploadUrl = "https://know.hu-st.com/upload.php";
const fileUrl = "https://know.hu-st.com/";
const nophoto = "https://know.hu-st.com/default.png";
const noimage = "https://know.hu-st.com/noimage.png";

function ShowLink(value) {
  if (!value) return;
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  if (!value) return;
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function DateToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  return year + "-" + month + "-" + date;
}

function DateTimeToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt.getHours().toString().padStart(2, "0");

  let minutes = dt.getMinutes().toString().padStart(2, "0");

  let seconds = dt.getSeconds().toString().padStart(2, "0");

  return (
    year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + seconds
  );
}

function AddMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

export {
  ShowLink,
  HtmlNewLine,
  uploadUrl,
  fileUrl,
  api,
  nophoto,
  noimage,
  DateToString,
  DateTimeToString,
  publicUrl,
  AddMonths
};
